{
  "$id": "wealthlane://forms/participant/ui",
  "schema": "./participant.model.json",
  "semanticId": "participantForm",
  "page": {
    "goBack": true
  },
  "wrapper": {
    "bordered": true
  },
  "layout": [
    {
      "rowId": "participant_detail",
      "fields": [
        {
          "scope": "#/properties/payrollId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 180
        },
        {
          "scope": "#/properties/employeeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 180
        },
        {
          "scope": "#/properties/employeeTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/firstName",
          "minCols": 2,
          "maxCols": 3,
          "minWidthPx": 120,
          "maxWidthPx": 550,
          "startNewRow": true
        },
        {
          "scope": "#/properties/middleName",
          "minCols": 1,
          "maxCols": 2,
          "minWidthPx": 160,
          "maxWidthPx": 520
        },
        {
          "scope": "#/properties/lastName",
          "minCols": 2,
          "maxCols": 3,
          "minWidthPx": 120,
          "maxWidthPx": 550
        },
        {
          "scope": "#/properties/dateOfBirth",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 200,
          "startNewRow": true
        },
        {
          "scope": "#/properties/workNumberCountryCodeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 150,
          "maxWidthPx": 250,
          "groupWith": "workNumber",
          "groupLabel": "Work Number"
        },
        {
          "scope": "#/properties/workNumber",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 250
        },
        {
          "scope": "#/properties/email",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 400
        },
        {
          "scope": "#/properties/residentStatusId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 200,
          "startNewRow": true
        },
        {
          "scope": "#/properties/countryId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 150,
          "maxWidthPx": 250
        },
        {
          "scope": "#/properties/ssn",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 180
        },
        {
          "scope": "#/properties/divisionId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 200,
          "startNewRow": true
        },
        {
          "scope": "#/properties/titleId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/costCenter",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 100,
          "maxWidthPx": 150
        },
        {
          "scope": "#/properties/hireDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/isSection16",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 110,
          "maxWidthPx": 180,
          "startNewRow": true
        },
        {
          "scope": "#/properties/isRule144",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 110,
          "maxWidthPx": 180
        },
        {
          "scope": "#/properties/settlementTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 200
        }
      ]
    },
    {
      "rowId": "tax_settlement",
      "title": "Set Up Tax Settlement Method",
      "fields": [
        {
          "scope": "#/properties/settlementConfiguration/properties/windowStart",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 260
        },
        {
          "scope": "#/properties/settlementConfiguration/properties/windowEnd",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 260
        },
        {
          "scope": "#/properties/settlementConfiguration/properties/defaultSettlementTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 300
        },
        {
          "scope": "#/properties/settlementConfiguration/properties/settlementMethods",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 300
        }
      ]
    },
    {
      "rowId": "work_location",
      "title": "Current Work Location",
      "fields": [
        {
          "scope": "#/properties/employmentAddressLine1",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 250,
          "maxWidthPx": 500
        },
        {
          "scope": "#/properties/employmentAddressLine2",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 250,
          "maxWidthPx": 500
        },
        {
          "scope": "#/properties/employmentCountryId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 150,
          "maxWidthPx": 220,
          "startNewRow": true
        },
        {
          "scope": "#/properties/employmentZipCode",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 180
        },
        {
          "scope": "#/properties/employmentStateId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/employmentStateText",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/employmentCityText",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 200
        }
      ]
    },
    {
      "rowId": "home_address",
      "title": "Home Address",
      "fields": [
        {
          "scope": "#/properties/homeAddressLine1",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 250,
          "maxWidthPx": 500
        },
        {
          "scope": "#/properties/homeAddressLine2",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 250,
          "maxWidthPx": 500
        },
        {
          "scope": "#/properties/homeCountryId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 150,
          "maxWidthPx": 220,
          "startNewRow": true
        },
        {
          "scope": "#/properties/homeZipCode",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 180
        },
        {
          "scope": "#/properties/homeStateId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/homeStateText",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/homeCityText",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/isMailingAddressDifferent",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 400,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "mailing_address",
      "title": "Mailing Address",
      "fields": [
        {
          "scope": "#/properties/mailingAddressLine1",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 250,
          "maxWidthPx": 500
        },
        {
          "scope": "#/properties/mailingAddressLine2",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 250,
          "maxWidthPx": 500
        },
        {
          "scope": "#/properties/mailingCountryId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 150,
          "maxWidthPx": 220,
          "startNewRow": true
        },
        {
          "scope": "#/properties/mailingZipCode",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 180
        },
        {
          "scope": "#/properties/mailingStateId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/mailingStateText",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/mailingCityText",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 200
        }
      ]
    },
    {
      "rowId": "transfer_agent",
      "title": "Transfer Agent",
      "fields": [
        {
          "scope": "#/properties/transferAgentCompanyId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 150,
          "maxWidthPx": 250
        },
        {
          "scope": "#/properties/taAccountNumber",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 150,
          "maxWidthPx": 250
        }
      ]
    },
    {
      "type": "udf",
      "moduleId": 1,
      "actionId": "GET_UDF_FIELDS",
      "title": "Other Information"
    }
  ],
  "modes": {
    "create": {
      "page": {
        "title": "Add Participants"
      },
      "addButton": {
        "label": "Add another participant",
        "variant": "primary-dark",
        "icon": "group_add",
        "fullWidth": true
      }
    },
    "edit": {
      "page": {
        "title": "Edit Participant"
      }
    },
    "view": {
      "page": {
        "title": "Participant Details",
        "goBack": false
      },
      "layout": [
        {
          "rowId": "summary",
          "title": "Summary",
          "columns": 4,
          "fields": [
            {
              "scope": "#/properties/employeeId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 100,
              "maxWidthPx": 160
            },
            {
              "scope": "#/properties/employeeTypeId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 100,
              "maxWidthPx": 160
            },
            {
              "scope": "#/properties/hireDate",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 100,
              "maxWidthPx": 160
            }
          ]
        },
        {
          "type": "divider"
        },
        {
          "rowId": "personal",
          "title": "Personal Information",
          "columns": 3,
          "fields": [
            {
              "scope": "#/properties/firstName",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 220
            },
            {
              "scope": "#/properties/middleName",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 220
            },
            {
              "scope": "#/properties/lastName",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 220
            },
            {
              "scope": "#/properties/dateOfBirth",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 140,
              "maxWidthPx": 220,
              "icon": "cake"
            },
            {
              "scope": "#/properties/email",
              "minCols": 1,
              "maxCols": 2,
              "minWidthPx": 180,
              "maxWidthPx": 360,
              "icon": "email"
            },
            {
              "scope": "#/properties/workNumber",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 140,
              "maxWidthPx": 220,
              "icon": "smartphone"
            }
          ]
        },
        {
          "type": "divider"
        },
        {
          "rowId": "legal",
          "title": "Compliance",
          "columns": 3,
          "fields": [
            {
              "scope": "#/properties/residentStatusId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 200
            },
            {
              "scope": "#/properties/countryId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 150,
              "maxWidthPx": 250
            },
            {
              "scope": "#/properties/ssn",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 180,
              "icon": "pin"
            },
            {
              "scope": "#/properties/isSection16",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 110,
              "maxWidthPx": 180,
              "icon": "gavel"
            },
            {
              "scope": "#/properties/isRule144",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 110,
              "maxWidthPx": 180,
              "icon": "gavel"
            }
          ]
        },
        {
          "type": "divider"
        },
        {
          "rowId": "employment",
          "title": "Employment",
          "columns": 3,
          "fields": [
            {
              "scope": "#/properties/payrollId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 200,
              "icon": "badge"
            },
            {
              "scope": "#/properties/divisionId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 140,
              "maxWidthPx": 260,
              "icon": "domain"
            },
            {
              "scope": "#/properties/titleId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 200
            },
            {
              "scope": "#/properties/costCenter",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 200,
              "icon": "point_of_sale"
            }
          ]
        },
        {
          "type": "divider"
        },
        {
          "rowId": "work_location",
          "title": "Current Work Location",
          "columns": 3,
          "fields": [
            {
              "scope": "#/properties/employmentAddressLine1",
              "minCols": 2,
              "maxCols": 2,
              "minWidthPx": 250,
              "maxWidthPx": 500
            },
            {
              "scope": "#/properties/employmentAddressLine2",
              "minCols": 2,
              "maxCols": 2,
              "minWidthPx": 250,
              "maxWidthPx": 500
            },
            {
              "scope": "#/properties/employmentCountryId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 150,
              "maxWidthPx": 220
            },
            {
              "scope": "#/properties/employmentStateId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 130,
              "maxWidthPx": 200
            },
            {
              "scope": "#/properties/employmentStateText",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 130,
              "maxWidthPx": 200
            },
            {
              "scope": "#/properties/employmentCityText",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 140,
              "maxWidthPx": 200
            },
            {
              "scope": "#/properties/employmentZipCode",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 180
            }
          ]
        },
        {
          "type": "divider"
        },
        {
          "rowId": "home_address",
          "title": "Home Address",
          "columns": 3,
          "fields": [
            {
              "scope": "#/properties/homeAddressLine1",
              "minCols": 2,
              "maxCols": 2,
              "minWidthPx": 250,
              "maxWidthPx": 500
            },
            {
              "scope": "#/properties/homeAddressLine2",
              "minCols": 2,
              "maxCols": 2,
              "minWidthPx": 250,
              "maxWidthPx": 500
            },
            {
              "scope": "#/properties/homeCountryId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 150,
              "maxWidthPx": 220
            },
            {
              "scope": "#/properties/homeStateId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 130,
              "maxWidthPx": 200
            },
            {
              "scope": "#/properties/homeStateText",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 130,
              "maxWidthPx": 200
            },
            {
              "scope": "#/properties/homeCityText",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 140,
              "maxWidthPx": 200
            },
            {
              "scope": "#/properties/homeZipCode",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 120,
              "maxWidthPx": 180
            }
          ]
        },
        {
          "type": "divider"
        },
        {
          "rowId": "transfer_agent",
          "title": "Transfer Agent",
          "columns": 3,
          "fields": [
            {
              "scope": "#/properties/transferAgentCompanyId",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 150,
              "maxWidthPx": 250
            },
            {
              "scope": "#/properties/taAccountNumber",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 150,
              "maxWidthPx": 250
            }
          ]
        },
        {
          "type": "udf",
          "moduleId": 1,
          "actionId": "GET_UDF_FIELDS",
          "title": "Other Information"
        }
      ]
    }
  }
}
